import React from "react";
import { Translate } from "react-localize-redux";

import {
	CasinoIcon,
	CloseIcon,
	LiveCasinoIcon,
	NoContentIcon,
	SearchIcon,
	TrashIcon,
} from "@pages/casino/assets/icons";
import { GameCard, GenericLoader, Modal, NoContent } from "@pages/casino/components";

import { SearchIconContainer, SearchWrapper } from "./elements.js";

import {
	CloseIconOverlay,
	Container,
	GameContainer,
	Heading,
	InfoText,
	SearchContainer,
	SearchFilter,
	SearchFilterWrapper,
	SearchNoContentWrapper,
} from "./elements.js";
import useController from "./useController.js";

const SearchModal = ({ onSearch, activeTab, onSearchToggle }) => {
	const {
		refs: { searchInputRef },
		state: { isToggled, isLive, isDesktop, searchValue, gameList, isLoading },
		handlers: { handleToggleChange, handleLiveToggle, handleSearchInput, handleClearInput },
	} = useController({ onSearch, activeTab, onSearchToggle });

	return (
		<Translate>
			{({ translate }) => (
				<SearchWrapper hasLessBorderRadius={window.HAS_LESS_BORDER_RADIUS}>
					<SearchIconContainer
						data-testid="button-casino-filter-search-game"
						isSmaller={window.CASINO_SEARCH_BUTTON_SMALLER}
						isDesktop={isDesktop}
						onClick={handleToggleChange}>
						{isDesktop && <span>{translate("casino.gameSearch")}</span>}
						<SearchIcon />
					</SearchIconContainer>

					<Modal
						open={isToggled}
						onClose={handleToggleChange}>
						<Container>
							<Heading>{translate("casino.GameSearch")}</Heading>
							<SearchFilterWrapper>
								<SearchFilter
									data-testid="button-search-modal-toggle-casino"
									isActive={isLive === false}
									onClick={() => handleLiveToggle(false)}>
									<CasinoIcon /> {translate("casino.casino")}
								</SearchFilter>
								<SearchFilter
									data-testid="button-search-modal-toggle-live"
									isActive={isLive === true}
									onClick={() => handleLiveToggle(true)}>
									<LiveCasinoIcon /> {translate("casino.liveCasino")}
								</SearchFilter>
							</SearchFilterWrapper>
							<SearchContainer
								noValue={searchInputRef.current?.value?.length < 4}
								hasItem={gameList.length > 0}>
								<SearchIcon
									width="24px"
									height="24px"
								/>
								<input
									data-testid="input-search-modal-search"
									ref={searchInputRef}
									onChange={handleSearchInput}
									autoFocus
								/>
								<TrashIcon
									data-testid="button-search-modal-clear"
									className="search-input-trash-icon"
									onClick={handleClearInput}
								/>
							</SearchContainer>
							{gameList?.length === 0 && !isLoading && (
								<InfoText>
									{searchValue?.length > 4 ? (
										<SearchNoContentWrapper>
											<NoContent
												content={""}
												showButton={false}
												icon={<NoContentIcon />}
												heading={translate("search.noMatch")}
											/>
										</SearchNoContentWrapper>
									) : (
										translate("search.infoText")
									)}
								</InfoText>
							)}

							{isLoading ? (
								<GenericLoader />
							) : (
								<>
									{gameList?.length > 0 && (
										<InfoText>
											{translate("search.matchCountInfo", {
												count: gameList?.length,
											})}
										</InfoText>
									)}
									<GameContainer className="search-game-container">
										{gameList?.map((game, index) => (
											<GameCard
												game={game}
												key={game?.id}
												size={
													game?.configs?.gameGrids[index]?.bannerSize ||
													"1x1"
												}
											/>
										))}
									</GameContainer>
								</>
							)}
							<CloseIconOverlay />
							<CloseIcon
								data-testid="button-search-modal-close"
								className="modal-close-icon"
								onClick={handleToggleChange}
							/>
						</Container>
					</Modal>
				</SearchWrapper>
			)}
		</Translate>
	);
};

export default SearchModal;
